import { render, staticRenderFns } from "./CommissionsTemplate.vue?vue&type=template&id=8d17f478&scoped=true&"
import script from "./CommissionsTemplate.vue?vue&type=script&lang=js&"
export * from "./CommissionsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CommissionsTemplate.vue?vue&type=style&index=0&id=8d17f478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d17f478",
  null
  
)

export default component.exports